export default __webpack_public_path__ + "static/media/Arrow-left-black.d2c3febd.svg";